const Size = {
    Small: 'SMALL',
    Medium: 'MEDIUM',
    Large: 'LARGE',
};
export default Size;
